(() => {
  const standardSource = 'Martial World Yohachi';
  const sizeLengths = { '2': '235 cm', '3': '255 cm', '4': '275 cm', '5': '295 cm', '6': '310 cm', '7': '325 cm', '8': '340 cm' };
  const colorValues = {
    Gold: '#D8B74A', Silver: '#A8A29E', White: '#F5F5F4', Red: '#B91C1C', 'Wine Red': '#7F1D1D', 'Golden Brown': '#B45309',
    Blue: '#1D4ED8', Navy: '#1E3A8A', 'Dark Navy': '#172554', 'Silver Gray': '#78716C', Black: '#1C1917', 'Fluorescent Pink': '#DB2777',
    Pink: '#EC4899', Vermilion: '#EA580C', 'Fluorescent Red': '#EF4444', 'Light Blue': '#60A5FA', 'Deep Light Blue': '#0284C7',
    Turquoise: '#14B8A6', Green: '#16A34A', 'Dark Green': '#166534', 'Emerald Green': '#059669', 'Blue Green': '#0F766E',
    'Fluorescent Green': '#84CC16', Orange: '#F97316', Brown: '#78350F', Yellow: '#EAB308', Beige: '#D6D3D1',
    'Fluorescent Orange': '#FB923C', Purple: '#7C3AED', Lavender: '#A78BFA',
  };

  const allowed = {
    source: [standardSource, 'Mizuno', 'Kusakura', 'Tokaido', 'Other'], width: ['4cm', '4.5cm'], size: Object.keys(sizeLengths), display: ['Latin', 'Katakana', 'Both'], color: Object.keys(colorValues),
    font: ['Kaisho', 'Gyosho'], height: ['2.0cm', '2.5cm', '3.0cm'], decoration: ['Standard', 'Shadow', 'Outline'],
    position: ['Recommended Right End', 'Left End', 'Center'], rankLines: Array.from({ length: 11 }, (_, index) => String(index)),
  };

  const initialise = (root) => {
    const form = root.querySelector('[data-belt-builder-form]');
    if (!form) return;
    form.noValidate = true;

    const panels = Array.from(root.querySelectorAll('[data-step-panel]'));
    const stepButtons = Array.from(root.querySelectorAll('[data-step-target]'));
    const previousButton = root.querySelector('[data-previous]');
    const nextButton = root.querySelector('[data-next]');
    const summary = root.querySelector('[data-error-summary]');
    const errorList = root.querySelector('[data-error-list]');
    const progressCurrent = root.querySelector('[data-progress-current]');
    const previewWindow = root.querySelector('[data-preview-window]');
    const previewBelt = root.querySelector('[data-preview-belt]');
    const previewEmbroidery = root.querySelector('[data-preview-embroidery]');
    const previewRoman = root.querySelector('[data-preview-roman]');
    const previewJapanese = root.querySelector('[data-preview-japanese]');
    const previewContext = root.querySelector('[data-preview-context]');
    const previewDojoText = root.querySelector('[data-preview-dojo-text]');
    const previewStyleText = root.querySelector('[data-preview-style-text]');
    const previewOtherText = root.querySelector('[data-preview-other-text]');
    const previewRank = root.querySelector('[data-preview-rank]');
    const previewRankLabel = root.querySelector('[data-preview-rank-label]');
    const previewColor = root.querySelector('[data-preview-color]');
    const previewPosition = root.querySelector('[data-preview-position]');
    const previewWidth = root.querySelector('[data-preview-width]');
    const previewDojo = root.querySelector('[data-preview-dojo]');
    const previewStyle = root.querySelector('[data-preview-style]');
    const previewOther = root.querySelector('[data-preview-other]');
    const previewLive = root.querySelector('[data-preview-live]');
    const sewing = root.querySelector('[data-sewing-sequence]');
    const reviewContent = root.querySelector('[data-review-content]');
    const standardPurchase = root.querySelector('[data-standard-purchase]');
    const customMakerQuote = root.querySelector('[data-custom-maker-quote-panel]');
    const customMakerName = root.querySelector('[data-custom-maker-name]');
    const submitButton = root.querySelector('[data-submit-button]');
    const submitInitiallyDisabled = submitButton?.disabled ?? true;
    const fields = {
      source: form.querySelector('[name="properties[Belt Source]"]'), width: form.querySelector('[name="properties[Belt Width]"]'), size: form.querySelector('[name="properties[Belt Size]"]'), length: form.querySelector('[name="properties[Belt Length]"]'), display: form.querySelector('[name="properties[Display Choice]"]'),
      roman: form.querySelector('[name="properties[Roman Name]"]'), pronunciation: form.querySelector('[name="properties[Pronunciation]"]'), japanese: form.querySelector('[name="properties[Japanese Display]"]'),
      color: form.querySelector('[name="properties[Thread Color]"]'), font: form.querySelector('[name="properties[Font Style]"]'), height: form.querySelector('[name="properties[Character Height]"]'),
      decoration: form.querySelector('[name="properties[Decoration]"]'), position: form.querySelector('[name="properties[Embroidery Position]"]'), dojo: form.querySelector('[name="properties[Dojo Name]"]'),
      style: form.querySelector('[name="properties[Style / School]"]'), other: form.querySelector('[name="properties[Other Embroidery Text]"]'), rankLines: form.querySelector('[name="properties[Rank Lines]"]'),
      special: form.querySelector('[name="properties[Special Instructions]"]'), preview: form.querySelector('[name="properties[Preview Notice]"]'), proofing: form.querySelector('[name="properties[Human Proofing]"]'),
      approval: form.querySelector('[name="properties[Customer Approval Before Production]"]'),
    };
    const requiredMarkers = Object.fromEntries(['roman', 'pronunciation', 'japanese'].map((key) => [key, root.querySelector(`[data-required-for="${key}"]`)]));
    const colorSwatches = document.createElement('div');
    colorSwatches.className = 'belt-builder__swatches';
    colorSwatches.dataset.colorSwatches = '';
    colorSwatches.setAttribute('role', 'group');
    colorSwatches.setAttribute('aria-label', root.dataset.colorSwatches);
    fields.color.querySelectorAll('option[value]').forEach((option) => {
      if (!option.value) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'belt-builder__swatch';
      button.dataset.color = option.value;
      button.style.setProperty('--swatch-color', colorValues[option.value]);
      button.setAttribute('aria-label', option.textContent.trim());
      button.setAttribute('aria-pressed', 'false');
      button.title = option.textContent.trim();
      button.addEventListener('click', () => {
        fields.color.value = option.value;
        fields.color.dispatchEvent(new Event('change', { bubbles: true }));
      });
      colorSwatches.appendChild(button);
    });
    fields.color.insertAdjacentElement('afterend', colorSwatches);
    const summaries = Object.fromEntries(Object.keys(fields).map((key) => [key, root.querySelector(`[data-summary="${key}"]`)]));
    const rules = [
      { key: 'source', panel: 0 }, { key: 'width', panel: 0 }, { key: 'size', panel: 0 },
      { key: 'display', panel: 1 }, { key: 'roman', panel: 1 }, { key: 'pronunciation', panel: 1 }, { key: 'japanese', panel: 1 },
      { key: 'color', panel: 2 }, { key: 'font', panel: 3 }, { key: 'height', panel: 3 }, { key: 'decoration', panel: 3 },
      { key: 'position', panel: 3 }, { key: 'rankLines', panel: 4 }, { key: 'preview', panel: 5 }, { key: 'proofing', panel: 5 }, { key: 'approval', panel: 5 },
    ].map((rule) => ({ ...rule, message: root.dataset[`error${rule.key[0].toUpperCase()}${rule.key.slice(1)}`] }));
    let currentPanel = 0;
    let visibleErrors = [];
    let reviewTimer;
    let announcementTimer;
    let fitFrame;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const valueOf = (field) => (field ? (field.type === 'checkbox' ? field.checked : field.value.trim()) : '');
    const displayOf = (field) => field?.tagName === 'SELECT' ? field.selectedOptions[0]?.textContent.trim() : valueOf(field);
    const format = (template, replacements) => Object.entries(replacements).reduce((text, [key, value]) => text.replace(`__${key}__`, value), template);
    const syncLength = () => {
      if (fields.length) {
        const length = sizeLengths[valueOf(fields.size)] || '';
        fields.length.value = length;
      }
    };
    const lengthMatchesSize = () => valueOf(fields.length) === (sizeLengths[valueOf(fields.size)] || '');
    const displayChoice = () => valueOf(fields.display);
    const needsLatin = () => ['Latin', 'Both'].includes(displayChoice());
    const needsKatakana = () => ['Katakana', 'Both'].includes(displayChoice());
    const isCustomSource = () => Boolean(valueOf(fields.source) && valueOf(fields.source) !== standardSource);
    const validText = (field, maxLength) => { const value = valueOf(field); return value.length > 0 && value.length <= maxLength && !/[\u0000-\u001f\u007f\r\n]/.test(value); };
    const isValid = (rule) => {
      const value = valueOf(fields[rule.key]);
      if (rule.key === 'roman') return !needsLatin() || validText(fields.roman, 40);
      if (rule.key === 'pronunciation') return !needsKatakana() || validText(fields.pronunciation, 80);
      if (rule.key === 'japanese') return !needsKatakana() || validText(fields.japanese, 24);
      if (rule.key === 'decoration') return allowed.decoration.includes(value);
      if (['preview', 'proofing', 'approval'].includes(rule.key)) return value === true;
      return allowed[rule.key]?.includes(value) === true;
    };
    const errorElement = (rule) => root.querySelector(`[data-error-for="${rule.key}"]`);
    const setFieldError = (rule, invalid) => {
      const field = fields[rule.key];
      const element = errorElement(rule);
      if (field) field.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      if (element) { element.textContent = invalid ? rule.message : ''; element.hidden = !invalid; }
    };
    const renderSummary = () => {
      errorList.textContent = '';
      visibleErrors.forEach((rule) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${fields[rule.key].id}`;
        link.textContent = rule.message;
        link.addEventListener('click', () => setPanel(rule.panel, false));
        item.appendChild(link);
        errorList.appendChild(item);
      });
      summary.hidden = visibleErrors.length === 0;
    };
    const showErrors = (errors) => { visibleErrors = errors; rules.forEach((rule) => setFieldError(rule, errors.includes(rule))); renderSummary(); };
    const validatePanel = (panel) => rules.filter((rule) => rule.panel === panel && !isValid(rule));
    const validateAll = () => rules.filter((rule) => !isValid(rule));
    const focusRule = (rule) => fields[rule.key]?.focus();
    const syncDisplayRequirements = () => {
      [['roman', needsLatin()], ['pronunciation', needsKatakana()], ['japanese', needsKatakana()]].forEach(([key, required]) => {
        fields[key].required = required;
        if (requiredMarkers[key]) requiredMarkers[key].hidden = !required;
      });
    };
    const syncSourceMode = () => {
      const custom = isCustomSource();
      root.classList.toggle('is-custom-maker', custom);
      if (standardPurchase) standardPurchase.hidden = custom;
      if (customMakerQuote) customMakerQuote.hidden = !custom;
      if (customMakerName) customMakerName.textContent = valueOf(fields.source) || root.dataset.thatMaker;
      if (submitButton) submitButton.disabled = submitInitiallyDisabled || custom;
      if (nextButton) {
        nextButton.disabled = custom;
        nextButton.hidden = custom || currentPanel === panels.length - 1;
        nextButton.setAttribute('aria-disabled', custom ? 'true' : 'false');
      }
    };
    const cancelReviewSequence = () => {
      window.clearTimeout(reviewTimer);
      root.classList.remove('is-sewing', 'is-review-ready');
      if (sewing) sewing.hidden = true;
      if (reviewContent) reviewContent.removeAttribute('aria-busy');
    };
    const startReviewSequence = () => {
      cancelReviewSequence();
      if (reducedMotion) { root.classList.add('is-review-ready'); return; }
      root.classList.add('is-sewing');
      if (sewing) sewing.hidden = false;
      if (reviewContent) reviewContent.setAttribute('aria-busy', 'true');
      reviewTimer = window.setTimeout(() => {
        root.classList.remove('is-sewing'); root.classList.add('is-review-ready');
        if (sewing) sewing.hidden = true;
        if (reviewContent) reviewContent.removeAttribute('aria-busy');
      }, 980);
    };
    const setPanel = (panel, moveFocus = true) => {
      currentPanel = Math.max(0, Math.min(isCustomSource() ? 0 : panel, panels.length - 1));
      panels.forEach((item, index) => { const active = index === currentPanel; item.classList.toggle('is-active', active); item.setAttribute('aria-hidden', active ? 'false' : 'true'); });
      stepButtons.forEach((button, index) => { if (index === currentPanel) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
      previousButton.disabled = currentPanel === 0;
      nextButton.disabled = isCustomSource() || currentPanel === panels.length - 1;
      nextButton.hidden = isCustomSource() || currentPanel === panels.length - 1;
      nextButton.setAttribute('aria-disabled', isCustomSource() ? 'true' : 'false');
      const stepLabel = stepButtons[currentPanel].querySelector('.visually-hidden')?.textContent || '';
      progressCurrent.textContent = format(root.dataset.progressTemplate, { CURRENT: currentPanel + 1, TOTAL: panels.length, LABEL: stepLabel });
      if (currentPanel === panels.length - 1) startReviewSequence(); else cancelReviewSequence();
      if (moveFocus) (panels[currentPanel].querySelector('input:not([type="hidden"]), select, textarea, button') || panels[currentPanel]).focus();
    };
    const goToPanel = (panel) => {
      syncLength();
      if (panel > currentPanel) {
        for (let index = currentPanel; index < panel; index += 1) {
          const errors = validatePanel(index);
          if (errors.length) { showErrors(errors); setPanel(index, false); focusRule(errors[0]); return; }
        }
      }
      showErrors([]); setPanel(panel);
    };
    const updateReview = () => Object.entries(summaries).forEach(([key, element]) => {
      if (!element) return;
      const empty = ['dojo', 'style', 'other', 'special', 'roman', 'pronunciation', 'japanese'].includes(key) ? root.dataset.emptyEntered : key === 'length' ? root.dataset.emptyDerived : root.dataset.emptySelected;
      element.textContent = displayOf(fields[key]) || empty;
    });
    const classFor = (prefix, value, fallback) => `${prefix}${value || fallback}`;
    const visiblePreviewRows = () => [previewRoman, previewJapanese, previewContext].filter((row) => row && !row.hidden && window.getComputedStyle(row).display !== 'none');
    const fitName = () => {
      const laneStyle = window.getComputedStyle(previewEmbroidery);
      const lanePadding = Number.parseFloat(laneStyle.paddingLeft) + Number.parseFloat(laneStyle.paddingRight);
      const available = Math.max(1, previewEmbroidery.clientWidth - lanePadding - 8);
      const rows = visiblePreviewRows();
      rows.forEach((row) => {
        row.style.removeProperty('--preview-name-font-size');
        row.style.removeProperty('--preview-context-font-size');
        const baseSize = Number.parseFloat(window.getComputedStyle(row).fontSize) || 48;
        const naturalWidth = row.scrollWidth;
        if (!naturalWidth) return;
        const targetSize = Math.max(5, Math.min(baseSize * 1.35, baseSize * available / naturalWidth));
        const property = row === previewContext ? '--preview-context-font-size' : '--preview-name-font-size';
        row.style.setProperty(property, `${targetSize}px`);
        const fittedSize = Math.max(5, targetSize * Math.min(1, available / Math.max(1, row.scrollWidth)));
        if (fittedSize !== targetSize) row.style.setProperty(property, `${fittedSize}px`);
      });
      const verticalPadding = Number.parseFloat(laneStyle.paddingTop) + Number.parseFloat(laneStyle.paddingBottom);
      const rowGap = Number.parseFloat(laneStyle.rowGap) || 0;
      const availableHeight = Math.max(1, previewEmbroidery.clientHeight - verticalPadding - rowGap * Math.max(0, rows.length - 1));
      const naturalHeight = rows.reduce((total, row) => total + row.scrollHeight, 0);
      const verticalScale = Math.min(1, availableHeight / Math.max(1, naturalHeight));
      if (verticalScale < 1) rows.forEach((row) => {
        const property = row === previewContext ? '--preview-context-font-size' : '--preview-name-font-size';
        const size = Number.parseFloat(window.getComputedStyle(row).fontSize) || 5;
        row.style.setProperty(property, `${Math.max(5, size * verticalScale)}px`);
      });
    };
    const fitPreview = () => {
      window.cancelAnimationFrame(fitFrame);
      fitFrame = window.requestAnimationFrame(() => {
        previewWindow.style.removeProperty('--preview-assembly-width');
        previewWindow.style.removeProperty('--preview-assembly-scale');
        const viewportWidth = previewWindow.clientWidth;
        const rankWidth = previewRank && !previewRank.hidden ? previewRank.scrollWidth : 0;
        visiblePreviewRows().forEach((row) => { row.style.removeProperty('--preview-name-font-size'); row.style.removeProperty('--preview-context-font-size'); });
        const contentWidth = Math.max(1, ...visiblePreviewRows().map((row) => row.scrollWidth));
        const nameSpace = Math.max(1, previewEmbroidery.clientWidth + rankWidth);
        const nameExtension = Math.min(300, Math.max(0, contentWidth - nameSpace));
        const assemblyWidth = Math.max(1, viewportWidth + rankWidth + nameExtension);
        previewWindow.style.setProperty('--preview-assembly-width', `${assemblyWidth}px`);
        previewWindow.style.setProperty('--preview-assembly-scale', Math.min(1, viewportWidth / assemblyWidth).toFixed(3));
        fitName();
      });
    };
    const updatePreview = () => {
      const roman = valueOf(fields.roman) || 'YOUR NAME';
      const japanese = valueOf(fields.japanese) || 'お名前';
      const color = valueOf(fields.color);
      const display = displayChoice() || 'Latin';
      const position = valueOf(fields.position) || 'Recommended Right End';
      const positionMap = { 'Recommended Right End': 'right', 'Left End': 'left', Center: 'center' };
      const displayMap = { Latin: 'latin', Katakana: 'katakana', Both: 'both' };
      const heightMap = { '2.0cm': '2', '2.5cm': '25', '3.0cm': '3' };
      previewRoman.textContent = roman; previewJapanese.textContent = japanese;
      const dojo = valueOf(fields.dojo);
      const style = valueOf(fields.style);
      const other = valueOf(fields.other);
      if (previewDojoText) { previewDojoText.textContent = dojo; previewDojoText.hidden = !dojo; }
      if (previewStyleText) { previewStyleText.textContent = style; previewStyleText.hidden = !style; }
      if (previewOtherText) { previewOtherText.textContent = other; previewOtherText.hidden = !other; }
      if (previewContext) previewContext.hidden = !dojo && !style && !other;
      const rankCount = Number.parseInt(valueOf(fields.rankLines), 10) || 0;
      previewRank.hidden = rankCount === 0;
      previewRank.dataset.count = String(rankCount);
      previewBelt.classList.toggle('has-rank-lines', rankCount > 0);
      previewRank.querySelectorAll('i').forEach((bar, index) => { bar.hidden = index >= rankCount; });
      if (previewRankLabel) previewRankLabel.textContent = format(root.dataset.rankLinesTemplate, { COUNT: rankCount });
      previewColor.textContent = displayOf(fields.color) || root.dataset.emptySelected; previewPosition.textContent = displayOf(fields.position);
      previewWidth.textContent = displayOf(fields.width) || root.dataset.emptySelected; previewDojo.textContent = dojo || root.dataset.emptyEntered;
      if (previewStyle) previewStyle.textContent = style || root.dataset.emptyEntered;
      if (previewOther) previewOther.textContent = other || root.dataset.emptyEntered;
      previewWindow.style.setProperty('--preview-thread', colorValues[color] || colorValues.Gold);
      previewBelt.dataset.thread = color || 'Gold';
      colorSwatches.querySelectorAll('[data-color]').forEach((button) => {
        const selected = button.dataset.color === color;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      ['is-position-right', 'is-position-left', 'is-position-center', 'is-width-standard', 'is-width-wide', 'is-height-2', 'is-height-25', 'is-height-3', 'is-font-kaisho', 'is-font-gyosho', 'is-decoration-standard', 'is-decoration-shadow', 'is-decoration-outline', 'is-display-latin', 'is-display-katakana', 'is-display-both'].forEach((name) => previewBelt.classList.remove(name));
      previewBelt.classList.add(classFor('is-position-', positionMap[position], 'right'));
      previewBelt.classList.add(valueOf(fields.width) === '4.5cm' ? 'is-width-wide' : 'is-width-standard');
      previewBelt.classList.add(classFor('is-height-', heightMap[valueOf(fields.height)], '2'));
      previewBelt.classList.add(classFor('is-font-', valueOf(fields.font).toLowerCase(), 'kaisho'));
      previewBelt.classList.add(classFor('is-decoration-', valueOf(fields.decoration).toLowerCase(), 'standard'));
      previewBelt.classList.add(classFor('is-display-', displayMap[display], 'latin'));
      previewBelt.classList.toggle('is-long-text', roman.length > 14 || japanese.length > 12);
      previewBelt.classList.toggle('has-context', Boolean(dojo || style || other));
      previewWindow.classList.toggle('is-long-name', roman.length > 14 || japanese.length > 12);
      fitPreview();
      window.clearTimeout(announcementTimer);
      announcementTimer = window.setTimeout(() => { previewLive.textContent = format(root.dataset.previewUpdateTemplate, { NAME: roman, COLOR: displayOf(fields.color) || root.dataset.threadNotSelected, POSITION: displayOf(fields.position), DETAILS: [dojo, style, other].filter(Boolean).join(' / ') || root.dataset.emptyEntered, RANK: rankCount }); }, 220);
    };
    const refreshAfterChange = (target) => {
      syncLength(); syncDisplayRequirements(); syncSourceMode();
      if (target === fields.source && isCustomSource() && currentPanel !== 0) setPanel(0, false);
      rules.filter((rule) => fields[rule.key] === target || target === fields.display || target === fields.height || target === fields.size).forEach((rule) => setFieldError(rule, !isValid(rule) && visibleErrors.some((item) => item.key === rule.key)));
      visibleErrors = visibleErrors.filter((rule) => !isValid(rule)); renderSummary(); updateReview(); updatePreview();
    };
    const disableBlankOptionalFields = () => {
      [[fields.roman, needsLatin()], [fields.pronunciation, needsKatakana()], [fields.japanese, needsKatakana()], [fields.dojo, false], [fields.style, false], [fields.other, false], [fields.special, false]].forEach(([field, needed]) => { if (field && !needed && !valueOf(field)) field.disabled = true; });
    };

    form.addEventListener('input', (event) => refreshAfterChange(event.target));
    form.addEventListener('change', (event) => refreshAfterChange(event.target));
    window.addEventListener('resize', fitPreview, { passive: true });
    nextButton.addEventListener('click', () => goToPanel(currentPanel + 1));
    previousButton.addEventListener('click', () => goToPanel(currentPanel - 1));
    stepButtons.forEach((button, index) => {
      button.addEventListener('click', () => goToPanel(index));
      button.addEventListener('keydown', (event) => {
        const movement = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: -index, End: stepButtons.length - index - 1 }[event.key];
        if (movement === undefined) return;
        event.preventDefault(); stepButtons[Math.max(0, Math.min(index + movement, stepButtons.length - 1))].focus();
      });
    });
    form.addEventListener('submit', (event) => {
      syncLength(); syncDisplayRequirements(); syncSourceMode();
      if (isCustomSource()) { event.preventDefault(); setPanel(0, false); return; }
      const errors = validateAll();
      if (!errors.length && !lengthMatchesSize()) { event.preventDefault(); setPanel(0, false); fields.size?.focus(); return; }
      if (!errors.length) { disableBlankOptionalFields(); return; }
      event.preventDefault(); showErrors(errors); setPanel(errors[0].panel, false); summary.focus();
    });

    root.classList.add('is-enhanced'); syncLength(); syncDisplayRequirements(); syncSourceMode(); updateReview(); updatePreview(); setPanel(0, false);
  };

  document.querySelectorAll('[data-belt-builder]').forEach(initialise);
})();
